import Vue from 'vue'
import App from './App.vue'
import {SSSA} from './components/sss-a';

import vueCustomElement from 'vue-custom-element'

import 'document-register-element/build/document-register-element'

import '@popperjs/core/dist/umd/popper.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';

import './assets/plugins/font-awesome';

import 'sass-loader';

require('./assets/styles/main.scss');
require('./assets/styles/bootstrap-styles.scss');

customElements.define('sss-a', SSSA);

Vue.use(vueCustomElement)
Vue.config.ignoredElements = ['sss-li','sss-div', 'sss-a','sss-ul','sss-span']

Vue.customElement('vue-widget', App)
